export default __webpack_public_path__ + "static/media/Huntington Jasperson - Engineering Design Portfolio.428648ce.pdf";